/* eslint react/no-direct-mutation-state: "off",'jsx-a11y/alt-text': 'off', eqeqeq: 'off' */
import React, { Component } from "react";
import { Button, Label, Form, FormGroup, Col, Modal } from "reactstrap";
import { connect } from "react-redux";
// import SortableTree from 'react-sortable-tree';
import classnames from 'classnames';
import Conversions from '../../../../Resources/Conversions';
import { makeGetCall, PutTenantDetailsAction, DeleteTenants, Getlicense } from '../../../../action/tenantAction';
import { ChangeDisplayinWorkOrderTenant, SetTenantId, GetBuildingAssociation, GetWorkOrderBuildings, BuildingAssociation, BuildingUnAssociation, SaveWorkOrderTenant } from '../../../../action/workorderAction';
import DeleteConfirmation from './WorkOrderDeleteConfirmation';
import EditIcon from '../../../../Assets/images/Icons__edit.svg';
import DeleteIcon from '../../../../Assets/images/Icons__trash2.svg';
import { Icon } from 'semantic-ui-react';
import WOEmployeeList from './WOEmployeeList';
import { CheckBoxSelection, Inject, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import '../../../../Assets/EnsembleStyles/MultiSelectDropDown.css';

let TenantDetail;
const ErrorPadding = {
    color: '#D42D27',
    fontfamily: 'Lato',
    fontStyle: 'italic',
    border: '2px solid #D42D27',
    height: '40px',
    padding: '10px',
    float: 'right',
};

const ErrorSign = {
    color: '#D42D27',
    paddingLeft: '8px',
    paddingTop: '0px',
    paddingRight: '14px',
    width: '22px',
    height: '22px',
    top: '406px',
    left: '959px'
};

class TenantDetails extends Component {
    async componentWillMount() {
        TenantDetail = this.props.TenantDetails;
        if (this.props.IsEdit) {
            var selectedBuildings = [];
            if(this.props.TenantDetails.buildings != null && this.props.TenantDetails.buildings != undefined){
            selectedBuildings = this.props.TenantDetails.buildings.map(el => (
                el.buildingId
            ));
            }

            this.setState({
                IsEdit: true,
                TenantId: TenantDetail.tenantId,
                TenantName: TenantDetail.tenantName,
                Address: TenantDetail.address,
                InvoiceEmail: TenantDetail.invoiceEmail,
                ContactPhone: TenantDetail.contactPhone,
                CurrencyId: TenantDetail.currencyId,
                Buildings: selectedBuildings,
                BuildingName: "",
                IsView: true
            });

            const l_Association = this.props.GetBuildingAssociation(TenantDetail.tenantId);
            const l_Buildings = this.props.GetWorkOrderBuildings();

            await Promise.all([l_Association, l_Buildings]);

            if(this.props.getWorkOrderBuildings !== undefined && this.props.getTenantAssociations !== undefined){
                var BuildingName = "", lDataSource = [];
                this.props.getTenantAssociations.forEach(el => (
                    BuildingName += this.props.getWorkOrderBuildings.filter(x => x.id == el.buildingID)[0].name + ", "
                ));

                lDataSource = this.props.getWorkOrderBuildings.filter(x => x.isDeleted == false).sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase()));
                this.setState({ BuildingName: BuildingName != "" ? BuildingName.substring(0, BuildingName.length - 2) : "", DataSource: lDataSource });
            }
        }else{
            const actionResponse = this.props.GetWorkOrderBuildings();
            actionResponse.then((result) => {
                if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length) {
                    var lDataSource = this.props.getWorkOrderBuildings.filter(x => x.isDeleted == false).sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase()));
                    this.setState({ DataSource: lDataSource });
                }
            })
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            IsEdit: false,
            create_error_msg: false,
            TenantId: 0,
            TenantName: '',
            Address: '',
            InvoiceEmail: '',
            ContactPhone: '',
            CurrencyId: 0,
            treeData: [],
            activeTab: '1',
            activeContent: '1',
            IsView: false,
            deletemodal: false,
            BuildingList: [],
            DataSource:[],
            error: {
                name: false,
                address: false,
                email: false,
                contact: false,
                building: false
            },
            Duplicate: false
        };

        this.building_dropdown_fields = { text: 'name', value: 'id' };
    }

    AssociateTenant() {
        this.props.SetTenantId(this.state.TenantId);
        this.props.ChangeDisplayinWorkOrderTenant('TenantAssociation');
    }

    CancelCreateTenant() {
        if (!this.state.IsEdit) {
            this.BackToList();
        } else {

            var selectedBuildings = []
            selectedBuildings = this.props.getTenantAssociations.map(el => (
                el.buildingID
            ));

            this.state.error.building = false;
            this.setState({
                IsView: true,
                create_error_msg: false,
                Buildings: selectedBuildings
            });
        }
    }

    AfterSave() {
        this.setState({
            IsView: true,
            TenantName: this.refs.New_Tenant_Name.value,
            Address: this.refs.Tenant_Billing_Address.value,
            InvoiceEmail: this.refs.Tenant_Billing_Email.value,
            ContactPhone: this.refs.Tenant_Contact_Address.value,
            create_error_msg: false,
            Buildings: this.refs.buildings != undefined ? this.refs.buildings.value : this.state.Buildings,
            BuildingName: this.refs.buildings != undefined ? this.refs.buildings.text : this.state.BuildingName
        });
    }

    SaveTenant() {
        this.state.error.name = false;
        this.setState({ create_error_msg: false, Duplicate: false });
        let Email = "^(([a-zA-Z0-9]|[!#$%&'*+/=?^_`{|}~-])[\\.]?)*([a-zA-Z0-9]+[!#$%&'*+/=?^_`{|}~-]*|[a-zA-Z0-9]*[!#$%&'*+/=?^_`{|}~-]+)[@]{1}([a-zA-Z0-9_-]*([\\.]?[a-zA-Z0-9_]+)+)$";
        let IsValid = true;

        let Tenant_Name = this.refs.New_Tenant_Name.value;
        let Billing_Addrs = this.refs.Tenant_Billing_Address.value;
        let Billing_Email = this.refs.Tenant_Billing_Email.value;
        let Contact_Addrs = this.refs.Tenant_Contact_Address.value;

        if (Tenant_Name === null || Tenant_Name === "") {
            IsValid = false;
            this.setState({ create_error_msg: true });
            this.state.error.name = true;
        } else {
            this.state.error.name = false;
        }

        if (this.refs.buildings.value != null && this.refs.buildings.value.length > 0)
            this.state.error.building = false;
        else {
            IsValid = false;
            this.state.error.building = true;
            this.setState({ create_error_msg: true });
        }
 
        if (Billing_Email != null && Billing_Email != "") {
            if (!Billing_Email.match(Email)) {
                IsValid = false;
                this.setState({ create_error_msg: true });
                this.state.error.email = true;
            } else {
                this.state.error.email = false;
            }
        } else {
            this.state.error.email = false;
        }
        if (this.props.getResponse !== undefined && this.props.getResponse.TenantsList !== null) {
            let lstTenants = this.props.getResponse.TenantsList;            
            if (lstTenants != undefined && lstTenants.length > 0) {
                lstTenants = lstTenants.filter(function (item) {             
                    return Tenant_Name.toUpperCase() == item.tenantName.toUpperCase()
                });
                if (lstTenants !== null && lstTenants.length > 0) {
                    if (lstTenants[0].tenantName !== this.state.TenantName) {
                        IsValid = false;
                        this.setState({ create_error_msg: true, Duplicate: true });
                        this.state.error.name = true;
                    }
                }
            }
        }
        if (IsValid) {
            if (!this.state.IsEdit) {
                var Hours_of_operation = []
                for (var i = 0; i < 7; i++) {
                    Hours_of_operation.push({
                        "DayID": i,
                        "startTime": Conversions.ConvertValueto24hourTime(0),
                        "endTime": Conversions.ConvertValueto24hourTime(0),
                    })
                }
                let Facility_Setup = { "SendToRequestedEmployee": true, "SendToAdditionalRecipient": false, "ToEmailAddress": [] };
                var l_Data = {
                    "TenantName": Tenant_Name,
                    "Address": Billing_Addrs,
                    "InvoiceEmail": Billing_Email,
                    "ContactPhone": Contact_Addrs,
                    "CurrencyId": 0,
                    "RatePerHour": 50,
                    "MinmumAfterHour": 2,
                    "RounderHours": 1,
                    "HasZoneRate": false,
                    "FacilitySetup": Facility_Setup,
                    "HasAfterHoursOption": false,
                    "NormalHours": Hours_of_operation,
                    "IsWorkOrder": true
                }

                var l_Buildings = this.refs.buildings.value.map( el => ({
                    "BuildingId" : el,
                    "TenantId" : 0
                })
                );

                var Data = {
                    "Tenant" : l_Data,
                    "Buildings" : l_Buildings
                }

                const actionResponse = this.props.SaveWorkOrderTenant(Data);
                actionResponse.then((result) => {

                    //this.props.BuildingAssociation(l_Buildings);
                    this.props.GetBuildingAssociation(this.props.getResponse.TenantId.tenantId);
                    this.props.makeGetCall();
                    this.props.Getlicense();
                    this.BackToList();
                })
            } else {
                var editData = {
                    "TenantName": Tenant_Name,
                    "Address": Billing_Addrs,
                    "ContactPhone": Contact_Addrs,
                    "InvoiceEmail": Billing_Email,
                    "CurrencyId": this.state.CurrencyId
                };
                
                var UnAssociate = [];
                this.props.getTenantAssociations.forEach(el => {
                    if(this.refs.buildings.value.filter(x => x == el.buildingID).length < 1)
                    {
                        var LineItem = {
                        "BuildingId" : el.buildingID,
                        "TenantId" : this.state.TenantId
                        }
                        UnAssociate.push(LineItem);
                    }
                });

                var Associate = [];
                this.refs.buildings.value.forEach(el => {
                    if(this.props.getTenantAssociations.filter(x => x.buildingId == el).length < 1)
                    {
                        var LineItem = {
                            "BuildingId" : el,
                            "TenantId" : this.state.TenantId
                            }
                        Associate.push(LineItem);
                    }
                });

                if(UnAssociate.length > 0)
                {
                const unAssociateactionResponse = this.props.BuildingUnAssociation(UnAssociate);
                unAssociateactionResponse.then((result) => {   
                    this.props.BuildingAssociation(Associate);     
                })
            }
            else if(Associate.length > 0)
            {
                this.props.BuildingAssociation(Associate);  
            }

                var tenant_Id = this.state.TenantId;
                const actionResponse = this.props.PutTenantDetailsAction(editData, tenant_Id);
                actionResponse.then((result) => {
                    this.props.GetBuildingAssociation(TenantDetail.tenantId);
                    this.props.makeGetCall();
                    this.AfterSave();
                })
            }
        }
    }

    EditTenant() {
        this.setState({ IsView: false });
    }

    DeleteTenant(){
        this.Deletetoggle();
    }

    Deletetoggle() {
        this.setState({ deletemodal: !this.state.deletemodal });
    }

    /* Delete Confirmation*/
    Delete = (someArg) => {
        if (someArg == "yes") {
            var Data = [];
            Data.push({"tenantId": this.state.TenantId});
            this.props.DeleteTenants(Data);
            this.BackToList();
        }
        this.Deletetoggle();
    }

    BackToList() {
        this.props.ChangeDisplayinWorkOrderTenant('TenantList');
    }


    render() {
        let Create_Error_Message = "";
        let activeContent = null;
        let label = this.props.getLabels;
        let Tenantlabel = this.props.getTenantLabels;
        var DropdownClass = this.state.error.building ? "customerrorhighlight" : ".e-input-group.e-delim-values"; 
        
        if (this.state.create_error_msg == true) {
            Create_Error_Message = <p style={ErrorPadding}>
                <Icon name='exclamation triangle' style={ErrorSign} /><b>Please correct all errors before continuing.</b>
            </p>
        }

        if (this.state.IsView) {
            activeContent = <div className="main_container">
                <Form>
                    <FormGroup row style={{ "margin-bottom": "1px" }}>
                        <Col sm={{ size: 4 }}>
                            <button className="btn btn-gray" style={{color:'white'}} onClick={() => { this.BackToList() }} > {"< BACK"} </button>
                        </Col>
                        <Col sm={{ size: 8 }}>
                            <img src={DeleteIcon} className="dbd_right_icon Ensemble_Icon Ensemble_question_Icon link_cursor" style={{ color: '#676767', valign: 'bottom', 'margin-top': '1px',width:'15px',height:'14px'}} onClick={() => { this.DeleteTenant() }} />
                            <img src={EditIcon} className="dbd_right_icon Ensemble_Icon Ensemble_question_Icon link_cursor"  style={{ color: '#676767', 'margin-top': '1px',width:'15px',height:'14px' }} onClick={() => { this.EditTenant() }} />
                        </Col>
                    </FormGroup>
                    <hr style={{ backgroundColor: '#666666', height: '1px', border: 'none' }} />
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <Label className='workorderheaderlbl'>{Tenantlabel['CreateTenant.ViewName.Text']}</Label><br />
                            <Label className="workorderlbl">{this.state.TenantName}</Label>
                        </Col>
                        <Col sm={{ size: 6 }}>
                            <Label className='workorderheaderlbl'>{Tenantlabel['CreateTenant.Address.Text']}</Label><br />
                            <Label className="workorderlbl">{this.state.Address}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <Label className='workorderheaderlbl'>{Tenantlabel['CreateTenant.InvoiceEmail.Text']}</Label><br />
                            <Label className="workorderlbl">{this.state.InvoiceEmail}</Label>
                        </Col>
                        <Col sm={{ size: 6 }}>
                            <Label className='workorderheaderlbl'>{Tenantlabel['CreateTenant.ContactInfo.Text']}</Label><br />
                            <Label className="workorderlbl">{this.state.ContactPhone}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <Label className='workorderheaderlbl'>{Tenantlabel['ManageTenants.Columns.Building.Text']+"*"}</Label><br />
                            <Label className="workorderlbl">{this.state.BuildingName}</Label>
                        </Col>
                        <Col sm={{ size: 6 }}>
                        </Col>
                    </FormGroup>
                    {/* <hr style={{ backgroundColor: '#666666', height: '1px', border: 'none' }} />
                    <FormGroup row>
                        <Col sm={{ size: 2 }}>
                            <Label className='workorderlbl'>Occupancy</Label>
                        </Col>
                        <Col sm={{ size: 10 }}>
                            <Button className="wo_employeebtn-black" onClick={() => { this.AssociateTenant() }} >CONFIGURE</Button>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 12 }}>
                            <div className="col-md-12" style={{ "height": "100%" }}>
                                <SortableTree treeData={this.state.treeData}
                                    onChange={treeData => this.setState({ treeData })}
                                    canDrag={false} canDrop={false} expanded={true} isVirtualized={false} />
                            </div>
                        </Col>
                    </FormGroup> */}
                    <hr style={{ backgroundColor: '#666666', height: '1px', border: 'none' }} />
                    <WOEmployeeList TenantId={this.state.TenantId}/>
                </Form>
            </div>
        } 

        return (
            this.state.IsView ? 
            <div className= {this.props.Premise ? "main_container" : "cloud_main_container"}>
                <div className="border_container">&nbsp;
                    {activeContent}
                        <Modal isOpen={this.state.deletemodal} deletemodal={this.deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")} >
                            <DeleteConfirmation parentToChildData={["Delete Tenant", "You are about to delete a tenant from the system. Do you want to continue?", "Close Window", "Delete Tenant"]} Delete={this.Delete} />
                        </Modal>
                </div>
            </div>
            :
            <div className="main_container">
                    <Form>
                        <div className="border_container">&nbsp;
                            <FormGroup row style={{ "margin-bottom": "1px" }}>
                                <Col sm={{ size: 11 }} style={{ 'margin-left': '15px' }}>
                                    <Label className='workordermainheaderlbl'>{this.state.IsEdit ? label['WorkOrders.EditTenant.Text'] : label['WorkOrders.CreateTenant.Text']}</Label>
                                    {Create_Error_Message}
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ size: 5 }} style={{ 'margin-left': '15px' }}>
                                    <Label className={(this.state.error.name) ? "errortext workorderlbl CreatePMlbl_margin" : "workorderlbl CreatePMlbl_margin"}>{Tenantlabel['CreateTenant.Name.Text']}</Label><br />
                                    <input type="text" ref='New_Tenant_Name' defaultValue={this.state.TenantName} style={{ width: '93%' }} className={(this.state.error.name) ? "errorhighlight pm_textbox" : "pm_textbox"} />
                                    <span hidden={!this.state.error.name}><Icon name='exclamation triangle' style={ErrorSign} /><br />
                                        <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>{this.state.Duplicate ? "Duplicate Tenant Name" : "An entry is required"}</b></Label></span>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ size: 5 }} style={{ 'margin-left': '15px' }}>
                                    <Label className={(this.state.error.address) ? "errortext workorderlbl CreatePMlbl_margin" : "workorderlbl CreatePMlbl_margin"}>{Tenantlabel['CreateTenant.Address.Text']}</Label><br />
                                    <textarea ref='Tenant_Billing_Address' defaultValue={this.state.Address} style={{ width: '93%' }} className={(this.state.error.address) ? "errorhighlight workorderedit-textarea workorderheaderlbl" : "workorderedit-textarea workorderheaderlbl"} />
                                    <span hidden={!this.state.error.address}><Icon name='exclamation triangle' style={ErrorSign} /><br />
                                        <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>An entry is required</b></Label></span>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ size: 5 }} style={{ 'margin-left': '15px' }}>
                                    <Label className={(this.state.error.email) ? "errortext workorderlbl CreatePMlbl_margin" : "workorderlbl CreatePMlbl_margin"}>{Tenantlabel['CreateTenant.InvoiceEmail.Text']}</Label><br />
                                    <input type="text" ref='Tenant_Billing_Email' defaultValue={this.state.InvoiceEmail} style={{ width: '93%' }} className={(this.state.error.email) ? "errorhighlight pm_textbox" : "pm_textbox"} />
                                    <span hidden={!this.state.error.email}><Icon name='exclamation triangle' style={ErrorSign} /><br />
                                        <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>In valid email</b></Label></span>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ size: 5 }} style={{ 'margin-left': '15px' }}>
                                    <Label className={(this.state.error.contact) ? "errortext workorderlbl CreatePMlbl_margin" : "workorderlbl CreatePMlbl_margin"}>{Tenantlabel['CreateTenant.ContactInfo.Text']}</Label><br />
                                    <textarea ref='Tenant_Contact_Address' defaultValue={this.state.ContactPhone} style={{ width: '93%' }} className={(this.state.error.contact) ? "errorhighlight workorderedit-textarea workorderheaderlbl" : "workorderedit-textarea workorderheaderlbl"} />
                                    <span hidden={!this.state.error.contact}><Icon name='exclamation triangle' style={ErrorSign} /><br />
                                        <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>An entry is required</b></Label></span>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ size: 5}} style={{ 'margin-left' : '15px'}}>
                                    <Label className={(this.state.error.building) ? "errortext workorderlbl CreatePMlbl_margin" :"workorderlbl CreatePMlbl_margin"}>{Tenantlabel['ManageTenants.Columns.Building.Text']+"*"}</Label>
                                    <span className="CreatePMlbl_margin" hidden={!this.state.error.building}><Label className="CreatePMlbl_margin" style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato', 'margin-left': '12px' }}><b>A selection is required.</b></Label></span>
                                    <br />
                                    <MultiSelectComponent id="MultiSelectCheckbox" cssClass={DropdownClass} width='93%' border='1px solid blue' ref='buildings' dataSource={this.state.DataSource} filterBarPlaceholder=' Start typing to search...' color="yellow"
                                        fields={this.building_dropdown_fields} showDropDownIcon={true} placeholder="- Select One or More -" value={this.state.Buildings} enableSelectionOrder={false} mode="CheckBox" >
                                        <Inject services={[CheckBoxSelection]} />
                                    </MultiSelectComponent>
                                    <span hidden={!this.state.error.building}><Icon name='exclamation triangle' style={ErrorSign} /></span>
                                </Col>
                            </FormGroup>
                        </div>
                        <br />
                        <FormGroup row>
                            <Col sm={{ size: 12 }}>
                                <Button className="wo_cancel_btn" style={{ 'float': 'right', 'margin-left': '6px' }} onClick={() => { this.CancelCreateTenant() }}>{label['WorkOrders.CreateTenant.Cancel.Text'] !== undefined ? label['WorkOrders.CreateTenant.Cancel.Text'] : "Cancel"}</Button>
                                <Button className="wo_save_btn" style={{ 'float': 'right' }} onClick={() => { this.SaveTenant() }}>{label['WorkOrders.CreateTenant.Save.Text'] !== undefined ? label['WorkOrders.CreateTenant.Save.Text'] : "Save"}</Button>
                            </Col>
                        </FormGroup>
                    </Form>
                </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        getResponse: state.tenantsRootReducer,
        getTenantLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getTenantAssociations: state.WorkorderRootReducer.TenantAssociations,
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings
    };
};
const mapDispatchToProps = dispatch => {
    return {
        makeGetCall: () => dispatch(makeGetCall()),
        SaveWorkOrderTenant: (TenantData) => dispatch(SaveWorkOrderTenant(TenantData)),
        PutTenantDetailsAction: (CompanyInformationEditedData, TenantID) => dispatch(PutTenantDetailsAction(CompanyInformationEditedData, TenantID)),
        ChangeDisplayinWorkOrderTenant: (data) => dispatch(ChangeDisplayinWorkOrderTenant(data)),
        SetTenantId: (Id) => dispatch(SetTenantId(Id)),
        GetBuildingAssociation: (TenantId) => dispatch(GetBuildingAssociation(TenantId)),
        DeleteTenants: (data) => dispatch(DeleteTenants(data)),
        Getlicense : () => dispatch(Getlicense()),
        GetWorkOrderBuildings: () => dispatch(GetWorkOrderBuildings()),
        BuildingAssociation: (data) => dispatch(BuildingAssociation(data)),
        BuildingUnAssociation: (data) => dispatch(BuildingUnAssociation(data))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(TenantDetails);